import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { handleXboxLink, xboxCallback } from '../../services/api';
import { CircularProgress, Box, Alert } from '@mui/material';

const XboxCallback: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleCallback = async () => {
      const searchParams = new URLSearchParams(location.search);
      const code = searchParams.get('code');
      const isLoginMode = searchParams.get('mode') === 'login';
      
      if (code) {
        try {
          if (isLoginMode) {
            // ログインモードの場合
            const response = await xboxCallback(code, 'login');
            
            if (response.data.access_token) {
              localStorage.setItem('token', response.data.access_token);
              localStorage.setItem('refreshToken', response.data.refresh_token);
              localStorage.setItem('user', JSON.stringify(response.data.user));
              
              // ログイン成功イベントを発火
              window.dispatchEvent(new Event('login'));
              
              // ホームページにリダイレクト
              setTimeout(() => {
                navigate('/', { 
                  state: { message: 'Xboxアカウントでログインしました' }
                });
              }, 2000);
            }
          } else {
            // 連携モードの場合
            await handleXboxLink(code);
            
            // 連携成功後プロフィール設定ページに戻る
            setTimeout(() => {
              navigate('/profile/settings', { 
                state: { message: 'Xboxアカウントの連携に成功しました' }
              });
            }, 2000);
          }
          
        } catch (error: any) {
          console.error('Xbox認証/連携に失敗しました:', error);
          setError(error.response?.data?.error || error.message || 'Xbox認証/連携に失敗しました');
        }
      } else {
        setError('認証コードが見つかりません');
      }
      
      setLoading(false);
    };
    
    handleCallback();
  }, [location, navigate]);

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '50vh',
      p: 3
    }}>
      {loading ? (
        <>
          <CircularProgress size={60} sx={{ mb: 3, color: '#6bb96b' }} />
          <Alert 
            severity="info" 
            sx={{ 
              maxWidth: 500,
              background: 'linear-gradient(135deg, rgba(107, 185, 107, 0.1), rgba(107, 185, 107, 0.05))',
              color: '#ffffff',
              border: '1px solid rgba(107, 185, 107, 0.2)',
              backdropFilter: 'blur(8px)',
              '& .MuiAlert-icon': {
                color: '#6bb96b'
              }
            }}
          >
            {new URLSearchParams(location.search).get('mode') === 'login'
              ? 'Xboxアカウントでのログイン処理中です...'
              : 'Xboxアカウントの連携処理中です...'}
          </Alert>
        </>
      ) : error ? (
        <Alert severity="error" sx={{ maxWidth: 500 }}>
          {error}
        </Alert>
      ) : (
        <Alert 
          severity="success" 
          sx={{ 
            maxWidth: 500,
            background: 'linear-gradient(135deg, rgba(107, 185, 107, 0.1), rgba(107, 185, 107, 0.05))',
            color: '#ffffff',
            border: '1px solid rgba(107, 185, 107, 0.2)',
            backdropFilter: 'blur(8px)',
            '& .MuiAlert-icon': {
              color: '#6bb96b'
            }
          }}
        >
          {new URLSearchParams(location.search).get('mode') === 'login'
            ? 'ログインに成功しました。正常にPULSEライブラリと連携されています。'
            : 'Xboxアカウントの連携に成功しました。プロフィール設定ページに戻ります。'}
        </Alert>
      )}
    </Box>
  );
};

export default XboxCallback; 